function lyticsCallback(profile) {
  const usersAudienceArray = profile.data.user.segments;
  // for loop to iterate through the usersAudienceArray and create a new array of segmentIds
  const segmentIds = [];
  for (let i = 0; i < usersAudienceArray.length; i += 1) {
    if (window.lyticsLookup[usersAudienceArray[i]]) {
      segmentIds.push(window.lyticsLookup[usersAudienceArray[i]]);
    }
  }
  // if the segmentIds array is empty, skip sending the event
  if (segmentIds.length === 0) {
    return;
  }

  const lyticsProfileEventObject = {
    event: 'user.lyticsProfile',
    'user.lyticsProfile': {
      audiences: segmentIds.join(','),
    },
  };
  window.pushGTMEvent(lyticsProfileEventObject);
  console.log('Lytics event fired. Pushed', segmentIds.length, 'segments to GA4');
}
/* eslint-disable-next-line no-undef */
jstag.call('entityReady', lyticsCallback);
